import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../components/Inputs/ResourceSelect";
import Select from "../../components/Inputs/Select";
import {
    getSettingsResourceSearchFilters,
    renderSettingsResourceLabel
} from "../../utils/helpers/settings";
import { useCustomFields } from "../Settings/CustomFields/context";

export const useAdditionalColFilters = () => {
    const { t } = useTranslation();

    const { peopleCustomFields } = useCustomFields();

    return useMemo(() => [
        {
            Header: t("pay-group"),
            accessor: "user.payGroupRes",
            canFilter: true,
            disableFilters: false,
            disableSortBy: true,
            filter: "resource-select",
            id: "user.payGroupRes",
            Filter: (
                <ResourceSelect
                    labelPropName="description"
                    resourcePath="/pay-group?pagination=off"
                    mode="multiple"
                    renderLabel={renderSettingsResourceLabel}
                    getSearchFilters={getSettingsResourceSearchFilters}
                    hasSearch
                />
            )
        },
        {
            Header: t("group"),
            accessor: "user.userGroups",
            canFilter: true,
            disableFilters: false,
            disableSortBy: true,
            filter: "resource-select",
            id: "user.userGroups",
            Filter: (
                <ResourceSelect
                    labelPropName="description"
                    resourcePath="/user-group?pagination=off"
                    mode="multiple"
                    renderLabel={renderSettingsResourceLabel}
                    getSearchFilters={getSettingsResourceSearchFilters}
                    hasSearch
                />
            )
        },
        {
            Header: t("groupings"),
            accessor: "user.groupings",
            canFilter: true,
            disableFilters: false,
            disableSortBy: true,
            filter: "resource-select",
            id: "user.groupings",
            Filter: (
                <ResourceSelect
                    labelPropName="description"
                    resourcePath="/grouping?pagination=off"
                    mode="multiple"
                    renderLabel={renderSettingsResourceLabel}
                    getSearchFilters={getSettingsResourceSearchFilters}
                    hasSearch
                />
            )
        },
        {
            Header: t("salary-or-hourly"),
            accessor: "user.salaryOrHourly",
            canFilter: true,
            disableFilters: false,
            disableSortBy: true,
            filter: "select",
            id: "user.salaryOrHourly",
            Filter: (
                <Select>
                    <Select.Option value="S">{t('salaried')}</Select.Option>
                    <Select.Option value="H">{t('hourly')}</Select.Option>
                </Select>
            )
        },
        {
            Header: t("custom-fields"),
            accessor: "user.customFields",
            canFilter: true,
            disableFilters: false,
            disableSortBy: true,
            filter: "resource-select",
            id: "user.customFields",
            Filter: (
                <ResourceSelect
                    labelPropName="description"
                    resourcePath="/custom-field/people?pagination=off"
                    mode="multiple"
                    renderLabel={renderSettingsResourceLabel}
                    getSearchFilters={getSettingsResourceSearchFilters}
                    hasSearch
                />
            )
        },
        {
            id: "custom-fields",
            canFilter: true,
            children: (peopleCustomFields || []).map((customField) => {
                return {
                    id: customField.code,
                    Header: customField.code,
                    filter: customField.type === "select" ? "select" : "text",
                    canFilter: true,
                    Filter: customField.type === "select" ? (
                        <Select>
                            {customField.options.map((option) => (
                                <Select.Option key={option.value} value={option.value}>
                                    {option.label}
                                </Select.Option>
                            ))}
                        </Select>
                    ) : undefined,
                };
            }),
        },
    ], [t, peopleCustomFields])
}